// ================================================================
// Event Bus — برای ارتباط loose-coupled بین components
// ================================================================
// به جای اینکه component A مستقیم component B رو صدا بزنه،
// از طریق event با هم حرف می‌زنن. نتیجه: گسترش راحت‌تر.

const listeners = new Map();

export const events = {
  /**
   * گوش دادن به یه event
   * @param {string} name
   * @param {Function} handler
   * @returns {Function} تابع unsubscribe
   */
  on(name, handler) {
    if (!listeners.has(name)) {
      listeners.set(name, new Set());
    }
    listeners.get(name).add(handler);
    return () => listeners.get(name)?.delete(handler);
  },

  /**
   * صدا زدن (publish) یه event
   * @param {string} name
   * @param {*} payload
   */
  emit(name, payload) {
    const handlers = listeners.get(name);
    if (!handlers) return;
    handlers.forEach(handler => {
      try {
        handler(payload);
      } catch (err) {
        console.error(`Error in event handler for "${name}":`, err);
      }
    });
  },

  /**
   * حذف تمام listenerهای یه event
   */
  off(name) {
    listeners.delete(name);
  }
};

// ================================================================
// لیست event‌های شناخته شده — برای مرجع و autocomplete
// ================================================================
export const EVENTS = {
  // State events
  STATE_CHANGED: 'state:changed',
  NODE_ADDED: 'node:added',
  NODE_MOVED: 'node:moved',
  NODE_REMOVED: 'node:removed',
  NODE_CONFIG_UPDATED: 'node:config-updated',
  CONNECTION_ADDED: 'connection:added',
  CONNECTION_REMOVED: 'connection:removed',
  CONNECTION_SELECTED: 'connection:selected',

  // UI events
  MODAL_OPEN_SETTINGS: 'modal:open-settings',
  MODAL_OPEN_PICKER: 'modal:open-picker',
  MODAL_CLOSE_ALL: 'modal:close-all',
  CONTEXT_MENU_OPEN: 'context-menu:open',
  CONNECT_DRAG_START: 'connect:drag-start',
  SIDEBAR_COMPANIES_TOGGLE: 'sidebar:companies-toggle',
  SCENARIO_LOADED: 'scenario:loaded',
  SHOW_OVERVIEW: 'view:show-overview',

  // i18n events
  LANGUAGE_CHANGED: 'i18n:changed'
};
